define((require) => {
    "use strict";

    const Enum                  = require("shared/util/Enum");
    const Sorting               = require("ui/dashboard/Sorting");
    const SortingHelperMethods  = require("ui/dashboard/SortingHelperMethods");
    const Storage               = require("shared/services/Storage");

    const SORTING_KEY = "sorting";

    const TemplateSorting = Enum.create("TemplateSorting", "value", {

        ALPHABETICAL: new Sorting("alphabetical", [{name: "name", direction: "Ascending"}]),

        CREATED: new Sorting("created", ["createdAt"])

    }, {
        // We need to create a closure so we have access to the TemplateSorting variable.
        current: () => SortingHelperMethods.current(Storage.Keys.TEMPLATE_SORTING_PANEL, SORTING_KEY, TemplateSorting, TemplateSorting.CREATED)(),

        set: SortingHelperMethods.set(Storage.Keys.TEMPLATE_SORTING_PANEL, SORTING_KEY),

        fromValue: (value) => SortingHelperMethods.fromValue(TemplateSorting)(value)
    });

    return TemplateSorting;
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/TemplateSorting.js